<template>
  <b-container class="pt-3 pb-3" fluid >
    <!-- User Interface controls -->
    <b-row>
        <b-col cols="12" lg="6" md="12">
            <b-col>
                <b-form-group label-cols-sm="3" label="เลือกวันที่" class="mb-2">
                    <b-tabs content-class="mt-3" fill>
                      <b-tab title="วัน" active>
                          <b-row>
                            <b-col cols="12" md="6">
                              <a-config-provider :locale="locale">
                              <a-date-picker
                                v-model="form.startDate"
                                :disabled-date="disabledStartDate"
                                format="YYYY-MM-DD"
                                placeholder="Start Date"
                                style="width: 100%"
                                @openChange="handleStartOpenChange"
                                @change="setDate"
                              />
                              </a-config-provider>
                            </b-col>
                            <b-col cols="12" md="6">
                              <a-config-provider :locale="locale">
                              <a-date-picker
                                v-model="form.endDate"
                                :disabled-date="disabledEndDate"
                                format="YYYY-MM-DD"
                                placeholder="End Date"
                                :open="endOpen"
                                style="width: 100%"
                                @openChange="handleEndOpenChange"
                                @change="setDate"
                              />
                              </a-config-provider>
                            </b-col>
                          </b-row>
                      </b-tab>
                      <b-tab title="เดือน">
                        <b-row>
                          <b-col cols="12" md="6">
                            <a-config-provider :locale="locale">
                            <a-month-picker
                              v-model="form.startMouth"
                              :disabled-date="disabledStartMouth"
                              format="YYYY-MM"
                              placeholder="Start Mouth"
                              style="width: 100%"
                              @openChange="handleStartMouth"
                              @change="setMonth"
                            />
                            </a-config-provider>
                          </b-col>
                          <b-col cols="12" md="6">
                            <a-config-provider :locale="locale">
                            <a-month-picker
                              v-model="form.endMouth"
                              :disabled-date="disabledEndMouth"
                              format="YYYY-MM"
                              placeholder="End Mouth"
                              :open="endOpenMouth"
                              style="width: 100%"
                              @openChange="handleEndMouth"
                              @change="setMonth"
                            />
                            </a-config-provider>
                          </b-col>
                        </b-row>
                      </b-tab>
                    </b-tabs>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label-cols-sm="3" label="ค้นหาแบบพิเศษ" class="mb-0">
                    <a-input-search v-model="form.keyWord" placeholder="" enter-button="Search" @search="setKeyword" allow-clear />
                    <span class="form-text"><span class="text-danger">*</span>ค้นหาด้วย <span class="text-danger">Username</span> หรือ <span class="text-danger">ชื่อบัญชีธนาคาร</span> หรือ <span class="text-danger">เลขที่บัญชีธนาคาร</span> หรือ <span class="text-danger">รหัสบัญชีลูกค้า</span> โดยไม่คำนึงถึงช่วงเวลา</span>
                </b-form-group>
            </b-col>
        </b-col>
        <b-col cols="12" lg="6" md="12">
            <b-col>
              <b-form-group label-cols-sm="3" label="คู่ค้า" class="mb-0">
                  <a-select
                    v-model="form.operator"
                    show-search
                    placeholder="กรุณาเลือกข้อมูล"
                    style="width: 100%"
                    @select="setOperator"
                  >
                      <a-select-option value="">
                          กรุณาเลือกข้อมูล
                      </a-select-option>
                      <a-select-option v-for="(item , index) in getOperator" :key="index" :value="item.name">
                          {{ item.name }}
                      </a-select-option>
                  </a-select>
              </b-form-group>
          </b-col>
            <b-col>
              <b-form-group label-cols-sm="3" label="ยูสเซอร์เนม" class="mb-0">
                  <a-select
                    v-model="form.username"
                    show-search
                    placeholder="กรุณาเลือกข้อมูล"
                    style="width: 100%"
                    @select="setUsers"
                    :disabled="(getUser)?false:true"
                  >
                      <a-select-option value="">
                          กรุณาเลือกข้อมูล
                      </a-select-option>
                      <a-select-option v-for="(item , index) in getUser" :key="index" :value="item.username">
                          {{ item.username }}
                      </a-select-option>
                  </a-select>
              </b-form-group>
          </b-col>
          <b-col>
              <b-form-group label-cols-sm="3" label="ธนาคาร" class="mb-0">
                  <a-select
                    v-model="form.status"
                    show-search
                    placeholder="กรุณาเลือกข้อมูล"
                    style="width: 100%"
                    @select="setBanks"
                    :disabled="(getBank)?false:true"
                  >
                      <a-select-option value="">
                          กรุณาเลือกข้อมูล
                      </a-select-option>
                      <a-select-option v-for="(item ,index) in getBank" :key="index" :value="item.bankName">
                          {{ item.bankName }}
                      </a-select-option>
                  </a-select>
              </b-form-group>
          </b-col>
          <b-col style="text-align: right">
              <a class="btn btn-warnig" href="javascript: void(0);" @click="clearSearch()"><i class="fe fe-x mr-1" /> Clear</a>
          </b-col>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import thTH from 'ant-design-vue/es/locale/th_TH'
import 'moment/locale/th'
import moment from 'moment'
moment.locale('th')
export default {
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getOperator: 'getOperator',
      getUser: 'getUser',
      getBank: 'getBank',
    }),
  },
  data() {
    return {
      locale: thTH,
      thTH,
      valueMonth: [],
      valueYear: [],
      inputDateRank: null,
      inputKeyword: null,
      inputOperator: null,
      inputUser: null,
      inputUsername: null,
      inputstatus: null,
      form: {
        operator: '',
        startDate: moment(),
        endDate: moment(),
        startMouth: moment(),
        endMouth: moment(),
        startYear: moment(),
        username: '',
        status: '',
        keyWord: '',
      },
      endOpen: false,
      endOpenMouth: false,
      endOpenYear: false,
    }
  },
  props: [
    'pageType',
  ],
  methods: {
    moment,
    ...mapActions({
      setDefult: 'setDefult',
      setDateRank: 'setDateRank',
      setOperarCode: 'setOperarCode',
      setUser: 'setUser',
      setSelectBank: 'setSelectBank',
      setSelectStatus: 'setSelectStatus',
      setKeywords: 'setKeywords',
    }),
    disabledStartDate(startDate) {
      const endDate = this.form.endDate
      if (!startDate || !endDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledEndDate(endDate) {
      const startDate = this.form.startDate
      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    disabledStartMouth(startMouth) {
      const endMouth = this.form.endMouth
      if (!startMouth || !endMouth) {
        return false
      }
      return startMouth.valueOf() > endMouth.valueOf()
    },
    disabledEndMouth(endMouth) {
      const startMouth = this.form.startMouth
      if (!endMouth || !startMouth) {
        return false
      }
      return startMouth.valueOf() > endMouth.valueOf()
    },
    handleStartMouth(open) {
      if (!open) {
        this.endOpenMouth = true
      }
    },
    handleEndMouth(open) {
      this.endOpenMouth = open
    },
    setDate() {
      const startDate = (this.form.startDate) ? this.form.startDate.format('YYYY/MM/DD 00:00:00') : moment().format('YYYY/MM/DD 00:00:00')
      const endDate = (this.form.endDate) ? this.form.endDate.format('YYYY/MM/DD 23:59:59') : moment().format('YYYY/MM/DD 23:59:59')

      this.setDateRank({ startDate: startDate, endDate: endDate })
    },
    setMonth(value, mode) {
      const startDate = (this.form.startMouth) ? this.form.startMouth.startOf('month').format('YYYY/MM/DD 00:00:00') : moment().startOf('month').format('YYYY/MM/DD 00:00:00')
      const endDate = (this.form.endMouth) ? this.form.endMouth.endOf('month').format('YYYY/MM/DD 23:59:59') : moment().endOf('month').format('YYYY/MM/DD 23:59:59')

      this.setDateRank({ startDate: startDate, endDate: endDate })
    },
    // setYear(value, mode) {
    //   this.valueYear = value
    //   const startDate = moment(value[0]._d).startOf('year').format('YYYY/MM/DD HH:mm:ss')
    //   const endDate = moment(value[1]._d).endOf('year').format('YYYY/MM/DD HH:mm:ss')
    //   this.setDateRank({ startDate: startDate, endDate: endDate })
    // },
    setOperator(value, option) {
      value = this.getOperator[option.key].operatorCode

      this.setOperarCode({ opertorCode: value, type: this.pageType, use: 'getUsers' })
    },
    setUsers(value) {
      this.setUser(value)
    },
    setStatus(value) {
      this.setSelectStatus(value)
    },
    setKeyword(value, event) {
      this.setKeywords(value)
    },
    setBanks(value, option) {
      value = this.getBank[option.key].id
      this.setSelectBank(value)
    },
    clearSearch() {
      this.form = {
        operator: '',
        startDate: moment(),
        endDate: moment(),
        startMouth: moment(),
        endMouth: moment(),
        startYear: moment(),
        username: '',
        status: '',
        keyWord: '',
      }
      this.setDefult({ type: 'bankPayment' })
    },
  },
  async created() {
    await this.setDefult({ type: this.pageType })
  },
}
</script>

<style>

</style>
